/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyMfaRequest
 */
export interface VerifyMfaRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyMfaRequest
     */
    userEmail: string;
    /**
     * 
     * @type {number}
     * @memberof VerifyMfaRequest
     */
    mfaCode: number;
}

export function VerifyMfaRequestFromJSON(json: any): VerifyMfaRequest {
    return VerifyMfaRequestFromJSONTyped(json, false);
}

export function VerifyMfaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyMfaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userEmail': json['userEmail'],
        'mfaCode': json['mfaCode'],
    };
}

export function VerifyMfaRequestToJSON(value?: VerifyMfaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userEmail': value.userEmail,
        'mfaCode': value.mfaCode,
    };
}

